
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3c4.959 0 9 4.042 9 9 0 1.406-.57 3.02-1.344 4.781s-1.77 3.631-2.781 5.375a101.013 101.013 0 01-4.063 6.406l-.813 1.188-.813-1.188s-2.039-2.918-4.063-6.406c-1.012-1.744-2.007-3.613-2.781-5.375S6.998 13.406 6.998 12c0-4.958 4.041-9 9-9zm0 2c-3.877 0-7 3.123-7 7 0 .803.43 2.316 1.156 3.969s1.73 3.484 2.719 5.188c1.572 2.71 2.546 4.144 3.125 5 .579-.856 1.553-2.29 3.125-5 .988-1.704 1.993-3.535 2.719-5.188S23 12.803 23 12c0-3.877-3.122-7-7-7zm0 5a2 2 0 11.001 3.999A2 2 0 0116 10z"}})])
          )
        }
      }
    